export const getSuccessData = (state) => state.success;